import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { Section, BackgroundImage, MobileBackgroundImage, Content, Items } from './ItemBank.styles.js';

var _excluded = ["children", "heading", "backgroundColor", "backgroundImage", "mainContent", "mobileBackgroundImage", "mobileTextColor", "textColor", "stackItemsOnMobile"];
var ItemBank = function ItemBank(_ref) {
  var children = _ref.children;
    _ref.heading;
    var _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? null : _ref$backgroundColor,
    _ref$backgroundImage = _ref.backgroundImage,
    backgroundImage = _ref$backgroundImage === void 0 ? null : _ref$backgroundImage,
    _ref$mainContent = _ref.mainContent,
    mainContent = _ref$mainContent === void 0 ? null : _ref$mainContent,
    _ref$mobileBackground = _ref.mobileBackgroundImage,
    mobileBackgroundImage = _ref$mobileBackground === void 0 ? null : _ref$mobileBackground,
    _ref$mobileTextColor = _ref.mobileTextColor,
    mobileTextColor = _ref$mobileTextColor === void 0 ? null : _ref$mobileTextColor,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? null : _ref$textColor,
    stackItemsOnMobile = _ref.stackItemsOnMobile,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Section, _extends({
    className: "leshen-item-bank",
    backgroundColor: backgroundColor,
    textColor: textColor,
    mobileTextColor: mobileTextColor
  }, props), backgroundImage && /*#__PURE__*/React.createElement(BackgroundImage, {
    mobileBackgroundImage: mobileBackgroundImage
  }, backgroundImage), mobileBackgroundImage && /*#__PURE__*/React.createElement(MobileBackgroundImage, null, mobileBackgroundImage), /*#__PURE__*/React.createElement(Content, {
    hasBackgroundImage: Boolean(backgroundImage)
  }, mainContent), /*#__PURE__*/React.createElement(Items, {
    hasBackgroundImage: Boolean(backgroundImage),
    stackItemsOnMobile: Boolean(stackItemsOnMobile)
  }, children));
};
var ItemBank$1 = ItemBank;

export { ItemBank$1 as default };
//# sourceMappingURL=index.js.map
